import Divider from "./Divider";

export default Divider;

export * from "./Divider";
